import React from 'react'
import PropTypes from 'prop-types'
import { Navigate, Route, Routes } from 'react-router-dom'
import Header from '../menu/Header'
import { useNavigate } from 'react-router'
import Page from './Page'


const TabbedPage = ({ tabs }) => {
  
  const navigate = useNavigate()
  
  return (
    <Page withTopBarAndMenu>
      <Routes>
        {tabs.map(tab =>
          <Route
            key={'route' + tab.key}
            path={tab.route}
            element={<>
              <Header
                setValue={navigate}
                value={tab.key}
                title={tab.label}
                tabs={tabs}
              >
                {tab.headerContent || <></>}
              </Header>
              {tab.content}
            </>}
          />,
        )}
        <Route path='*' element={<Navigate replace to={tabs[0].route} />} />
      </Routes>
    </Page>
  )
}

TabbedPage.propTypes = {
  tabs: PropTypes.array.isRequired,
}

export default TabbedPage
